import api from "./api";
import { deviceProfile, installedApp, isAppleMobile } from "./deviceProfile";
let installPrompt = null;
let activationEpoch = 0;
window.addEventListener("beforeinstallprompt", (event) => { event.preventDefault(); installPrompt = event; });
window.addEventListener("appinstalled", () => { installPrompt = null; });
export const getInstallPrompt = () => installPrompt;
export const prepareDevice = async (userId) => {
  const epoch = activationEpoch;
  if (!("serviceWorker" in navigator)) return;
  const registration = await register();
  if (epoch !== activationEpoch) return;
  const optin = localStorage.getItem(`gsp_push_optin_${userId}`);
  await activateUser(registration, optin === "false" ? null : userId);
  if (pushSupported() && Notification.permission === "granted" && optin !== "false") {
    const existing = await registration.pushManager.getSubscription();
    if (existing || optin === "true") await enableDevicePush(userId, false);
  }
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const register = async () => { await navigator.serviceWorker.register("/sw.js", { scope: "/", updateViaCache: "none" }); return navigator.serviceWorker.ready; };
const bytes = (base64) => Uint8Array.from(atob((base64 + "=".repeat((4 - base64.length % 4) % 4)).replace(/-/g, "+").replace(/_/g, "/")), (c) => c.charCodeAt(0));
const activateUser = async (registration, userId) => {
  if (!registration.active) throw new Error("Notification service is not ready. Please retry.");
  await new Promise((resolve, reject) => {
    const channel = new MessageChannel();
    const timer = setTimeout(() => { channel.port1.close(); reject(new Error("Notification setup could not be confirmed. Reopen the app and retry enabling notifications.")); }, 5000);
    channel.port1.onmessage = (event) => { clearTimeout(timer); channel.port1.close(); event.data?.ok ? resolve() : reject(new Error("Notification setup could not be saved on this device.")); };
    registration.active.postMessage({ type: "ACTIVE_USER", user_id: userId }, [channel.port2]);
  });
};
export const enableDevicePush = async (userId, requestPermission = true) => {
  const epoch = activationEpoch, session = localStorage.getItem("gsp_token");
  if (isAppleMobile() && !installedApp()) throw new Error("On iPhone/iPad, add CRM to your Home Screen from Safari, open that icon, then enable notifications (iOS 16.4 or later).");
  if (!pushSupported()) throw new Error("Install the CRM on your Home Screen and use a supported browser.");
  if (requestPermission && await Notification.requestPermission() !== "granted") throw new Error("Notifications are blocked. Allow them in your browser or device settings.");
  if (Notification.permission !== "granted") return false;
  const registration = await register();
  const { data } = await api.get("/push/config");
  if (!data.configured) throw new Error("Device notification keys are not configured on the server.");
  let subscription = await registration.pushManager.getSubscription();
  const publicKey = bytes(data.public_key);
  if (subscription && subscription.options.applicationServerKey && Array.from(new Uint8Array(subscription.options.applicationServerKey)).join() !== Array.from(publicKey).join()) {
    await subscription.unsubscribe(); subscription = null;
  }
  if (!subscription) subscription = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: publicKey });
  if (epoch !== activationEpoch || !session || session !== localStorage.getItem("gsp_token")) return false;
  await activateUser(registration, userId);
  if (epoch !== activationEpoch || session !== localStorage.getItem("gsp_token")) return false;
  await api.post("/push/subscribe", { ...subscription.toJSON(), ...deviceProfile() });
  if (epoch !== activationEpoch || session !== localStorage.getItem("gsp_token")) return false;
  localStorage.setItem(`gsp_push_optin_${userId}`, "true");
  window.dispatchEvent(new Event("gsp:push-status"));
  return true;
};
export const disableDevicePush = async () => {
  activationEpoch += 1;
  if (!("serviceWorker" in navigator)) return;
  const registration = await navigator.serviceWorker.getRegistration("/");
  if (!registration) return;
  await activateUser(registration, null);
  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    await subscription.unsubscribe();
    await api.post("/push/unsubscribe", { endpoint: subscription.endpoint }, { timeout: 4000 });
  }
};